import { useMutation, MutationHookOptions, gql } from "@apollo/client"

const CreateGpTerminationMutation = gql`
  mutation CreateGpTermination(
    $engagementId: ID!
    $offboardingCategoryId: ID
    $lastWorkingDay: ISO8601Date
    $lastDayOn: ISO8601Date
    $payrollPayoutMonthChange: Boolean
    $proposedPayoutMonth: ISO8601Date
    $payrollPayoutMonthReason: String
  ) {
    createGpTermination(
      input: {
        engagementId: $engagementId
        offboardingCategoryId: $offboardingCategoryId
        lastWorkingDay: $lastWorkingDay
        lastDayOn: $lastDayOn
        payrollPayoutMonthChange: $payrollPayoutMonthChange
        proposedPayoutMonth: $proposedPayoutMonth
        payrollPayoutMonthReason: $payrollPayoutMonthReason
      }
    ) {
      errors
    }
  }
`

export const useCreateGpTermination = (options?: MutationHookOptions) => {
  return useMutation(CreateGpTerminationMutation, options)
}
